import React from "react";
import {
  CheckCircle2,
  Clock3,
  CalendarX2,
  CircleSlash2,
  XCircle,
  HelpCircle,
} from "lucide-react";
import { getStatusStyle } from "./couponUi";

const STATUS_LABELS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  EXPIRED: "Expired",
  EXHAUSTED: "Exhausted",
  CANCELLED: "Cancelled",
};

const STATUS_ICONS = {
  ACTIVE: CheckCircle2,
  INACTIVE: Clock3,
  EXPIRED: CalendarX2,
  EXHAUSTED: CircleSlash2,
  CANCELLED: XCircle,
};

export default function CouponStatusBadge({ status }) {
  const key = typeof status === "string" ? status.toUpperCase() : "";
  const label = STATUS_LABELS[key] || (status ? String(status) : "Unknown");
  const { bg, text, border } = getStatusStyle(key);
  const Icon = STATUS_ICONS[key] || HelpCircle;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        backgroundColor: bg,
        color: text,
        border: `1px solid ${border}`,
        borderRadius: 999,
        padding: "2px 10px",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: "18px",
        whiteSpace: "nowrap",
      }}
    >
      <Icon size={13} aria-hidden="true" />
      {label}
    </span>
  );
}
